import { CardHistoryTabs } from "@/modules/card/common/enum";
import { getCardHistoryTabItems } from "@/modules/card/helpers";
import { AppPaths } from "@/shared/common/enums";
import { SeeMore } from "@/shared/components";
import { buildRoute } from "@/shared/helpers";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { Tab } from "@ab.uitools/ui-library/components/Tab";
import { type ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { CardDetailOfflineHistory } from "./CardDetailOfflineHistory";
import { CardDetailOnlineHistory } from "./CardDetailOnlineHistory";

interface Props {
  cardId: string;
}

type ITemplate = {
  [key in CardHistoryTabs]: ReactNode;
};

export const CardDetailHistory = ({ cardId }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState<CardHistoryTabs>(CardHistoryTabs.Transactions);

  const onTabChange = (value: string) => {
    setSelectedTab(value as CardHistoryTabs);
  };

  const handleSeeMore = () => {
    const url = buildRoute(AppPaths.CardHistory, { cardId });
    navigate(url);
  };

  const template: ITemplate = {
    [CardHistoryTabs.Transactions]: <CardDetailOfflineHistory cardId={cardId}/>,
    [CardHistoryTabs.OnlineTransactions]: <CardDetailOnlineHistory cardId={cardId}/>,
  };

  return (
    <div className="mt-40">
      <div className="flexbox align-items--center pb-20">
        <Heading className="content-title" size="xsmall" weight="bolder">
          {t("cards.cardHistory")}
        </Heading>
        <SeeMore action={handleSeeMore} className="ml-8 mt-4"/>
      </div>
      <div
        className="flexbox justify-content--between align-items--center full-width tabs-section mb-16">
        <Tab
          size="small"
          color="light"
          tabItems={getCardHistoryTabItems({ t })}
          selectedValue={selectedTab}
          onSelect={(value) => onTabChange(value as string)}
        />
      </div>
      {template[selectedTab]}
    </div>
  );
};
